import { css } from '@emotion/react'
import React, { ReactNode } from 'react'
import { rem } from '../../styles/mixin.styles'

import { space, breakpoints, height } from '../../styles/variables.styles'

type Props = {
  children: ReactNode
}

/**
 * Main
 *
 * @param children children
 * @returns main tag
 */
export const Main = ({ children }: Props) => {
  return <main css={mainStyles}>{children}</main>
}

const mainStyles = css`
  margin-top: clamp(${rem(height.header)}, 7vw, ${rem(height.headerMax)});
  width: min(100%, ${rem(breakpoints.content)});
  padding-bottom: clamp(${space.xxl}, 10vw, calc(2 * ${space.xxl}));
`
